import React, { useEffect, useState } from 'react';
import '../styles/Pricing.css';
import { Header, Footer, PricingCard, Loading } from '../components';
import { checkOnAuthStateChanged, cloudFunctionV2, getDocument, recordEvent } from '../functions';
import { useNavigate } from 'react-router-dom';
import { pricingTiers } from '../defaults';

function Pricing() {
    const [loggedIn, setLoggedIn] = useState(null);
    const [email, setEmail] = useState("");
    const [companyId, setCompanyId] = useState(null);
    const [disabled, setDisabled] = useState(false);
    const [customerId, setCustomerId] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const origin = window.location.origin;
    const mode = origin.includes("localhost") ? "test" : "live";

    useEffect(() => {
        document.title = "Pricing | Clozers";
        const fetchUserData = async() => {
            const user = await checkOnAuthStateChanged();
            if ( user.status === 200 ) {
                const colRef = "users";
                const docRef = user.userId;
                setLoggedIn(true);
                const queryData = await getDocument(colRef, docRef);
                if ( queryData.status === 200 ) {
                    const data = queryData.data.data;
                    setEmail(data.email);
                    setCustomerId(data.customerId);

                    const queryCompanyData = await getDocument("companies", data.companyId);
                    if ( queryCompanyData.status === 200 ) {
                        setCompanyId(queryCompanyData.data.data.companyId);
                    }
                    else {
                        navigate("/company-setup");
                    }
                }
            }
            else {
                setLoggedIn(false);
            }
            setLoading(false);
        };

        fetchUserData();
    }, [navigate]);

    const createAccount = () => {
        recordEvent("choose_free_plan", {});
        navigate("/sign-up");
    };

    const getCheckoutLink = async(item) => {
        setLoading(true);
        setDisabled(true);
        recordEvent("choose_plan", {
            price: item.price
        });
        const url = process.env.REACT_APP_GENERATE_STRIPE_CHECKOUT;
        // Retrieve Tolt referral code (if any) that the Tolt script places on the window object
        const toltReferral = window?.tolt_referral || null;

        // Build metadata; only include the referral when it exists
        const metadata = {
            companyId: companyId,
            credits: item.credits,
        };
        if (toltReferral) {
            metadata.tolt_referral = toltReferral;
        }

        const params = {
            mode: mode,
            priceId: mode === "test" ? item.testId : item.liveId,
            successURL: `${origin}`,
            cancelURL: `${origin}/pricing`,
            email: email,
            customerId: customerId,
            metadata,
        };

        const queryData = await cloudFunctionV2(url, params);
        if ( queryData.status === 200 ) {
            const data = queryData.data;
            const url = data.url;
            window.open(url, "_self");
        }
        else {
            console.log(queryData);
        }
        setDisabled(false);
        setLoading(false);
    };

    return (
        <div className="pricing-outer-container">
            <Header
                loggedIn={loggedIn}
            />
            <div className="pricing-inner-container">
                {
                    loading === true &&
                    <Loading />
                }
                <div className="pricing-title-container">
                    <h1 className="heading-large-bold colour-primary text-align-center">
                        Pricing
                    </h1>
                </div>
                <div className="pricing-body-container">
                    {
                        pricingTiers.map((item, index) =>
                            ((loggedIn === false) || (loggedIn === true && companyId !== null)) &&
                            <PricingCard
                                item={item}
                                key={index}
                                cta={loggedIn === false ? () => createAccount() : () => getCheckoutLink(item)}
                                disabled={disabled}
                            />
                        )
                    }
                </div>
            </div>
            <Footer />
        </div>
    )
};

export default Pricing;